import React, { FC } from 'react';
import { Tag } from 'components/atoms/tag';
import { useTranslate } from 'hooks/use-translation';
import { getRandomColor } from 'utils/get-random-color';
import { CellRendererParams } from '../types';
import { Caption } from './component';
import { MarkedTooltip } from './tooltips';

export const OptionRenderer: FC<CellRendererParams> = ({ value, data }) => {
  const translate = useTranslate();

  if (!value) {
    return (
      <MarkedTooltip isMarked={data.marked}>
        <Caption>{translate('select_with_ellipse')}</Caption>
      </MarkedTooltip>
    );
  }

  return (
    <MarkedTooltip isMarked={data.marked}>
      <Tag color={getRandomColor(value?.label)}>{value?.label}</Tag>
    </MarkedTooltip>
  );
};
